import React from "react";

import "../../scss/molecules/_approach.scss";

class Approach extends React.Component {
  render() {
    return (
      <div className="approach">
        <div className="approach-media">
          <img src={this.props.icon} alt={this.props.iconAlt} />
        </div>
        <div className="approach-body">
          <p className="approach-title">{this.props.title}</p>
          <p className="approach-description">{this.props.description}</p>
        </div>
      </div>
    );
  }
}

export default Approach;
